<template>
  <v-dialog v-model="dialog.active" max-width="800" persistent>
    <v-card>
      <v-title>{{ dialog.title }}</v-title>
      <vonex-radio
        v-model="backupType"
        name="backupType"
        grid-list-md
        text-xs-center
        class="backupDialogRadioGroup"
      >
        <v-layout row wrap>
          <v-flex v-if="isNbn" xs6>
            <v-radio label="4G Voice Only Backup" value="4g"></v-radio>
          </v-flex>
          <v-flex xs6>
            <v-radio label="Assure" value="assure"></v-radio>
          </v-flex>
        </v-layout>
      </vonex-radio>
      <v-layout row wrap>
        <v-flex xs4>
          <v-select
            v-model="modem"
            :items="modemOptions"
            item-text="label"
            item-value="value"
            box
            label="Select Modem Type"
            name="modem"
            @change="updateTable"
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :hide-default-footer="true"
            :items="rowData"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-center">{{ props.item.contract }}</td>
              <td class="text-xs-center">${{ props.item.price }}</td>
              <td class="text-xs-center">${{ props.item.discount }}</td>
              <td class="text-xs-center">${{ props.item.upfront }}</td>
              <td class="text-xs-center">${{ props.item.monthly }}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" :disabled="!modem" text @click="saveBackup">
          Yes
        </v-btn>
        <v-btn class="accent" color="black" text @click="$emit('closeDialog')">
          No
        </v-btn>
      </v-card-actions>
    </v-card>

    <message-alert :component="message"></message-alert>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapHardwareActions } =
  createNamespacedHelpers(`orders/hardware`);

const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);
const { mapActions: mapInternetActions, mapMutations: mapInternetMutations } =
  createNamespacedHelpers(`orders/internet`);
import { mapHandsetFields } from '@/store/modules/orders';
export default {
  name: 'Backup4GDialog',
  props: {
    dialog: { type: Object },
    item: { type: Object, default: null },
    handsets: { type: Array },
    handset: { type: Object, required: true },
    currentIndex: { type: Number, required: true },
  },
  computed: {
    ...mapHandsetFields(['rows']),
    internet: {
      get() {
        return this.item;
      },
      set(value) {
        this.$emit('update:internet', value);
      },
    },
    setDiscount() {
      const vm = this;
      let discount;
      switch (vm.item.contractTerm) {
        case 0:
          discount = 0;
          break;

        case 12:
          discount = 100;
          break;

        case 36:
          discount = 200;
          break;

        case 48:
          discount = 200;
          break;
      }
      if (
        this.item.internetType.toLowerCase() === 'nbn' &&
        vm.item.contractTerm != 0
      )
        return discount + 100;

      return discount;
    },
    modemOptions() {
      const vm = this;
      var handsets = [
        'Archer VR2100v',
        'Netcomm NL19MESH',
        'Billion BiPAC 4520VAOZ R3',
      ];
      let res = vm.$props.handsets
        .filter((x) => x.hardwareCategoryID == 2 && x.status == 'active')
        .filter((x) => handsets.includes(x.model))
        .map(({ handsetID, model }) => ({
          label: model,
          value: handsetID,
        }));
      return res;
    },
  },
  data() {
    return {
      modem: '',
      headers: [
        {
          text: 'Backup',
          align: 'left',
          sortable: false,
          value: 'name',
        },
        {
          text: 'Contract Term',
          align: 'center',
          sortable: false,
          value: 'contract',
        },
        {
          text: 'Price',
          align: 'center',
          sortable: false,
          value: 'price',
        },
        {
          text: 'Discount',
          align: 'left',
          sortable: false,
          value: 'discount',
        },
        {
          text: 'Upfront Payment',
          align: 'left',
          sortable: false,
          value: 'upfront',
        },
        {
          text: 'Monthly Repayment',
          align: 'left',
          sortable: false,
          value: 'monthly',
        },
      ],
      rowData: [],
      backupType: '',
      discount: 0.0,
      isNbn: false,
      price: 0.0,
      payload: {},
    };
  },
  methods: {
    ...mapInternetActions(['setMessage']),

    saveBackup() {
      let vm = this;
      vm.payload = {
        ...vm.payload,
        hardwareUpfront: vm.rowData[0].upfront,
        hardwareMonthly: parseFloat(vm.rowData[0].monthly),
        hardwareID: vm.modem,
      };

      vm.internet.dataBackup = vm.payload;
      vm.$emit('update:internet', {
        index: vm.currentIndex,
        item: vm.internet,
      });

      vm.$emit('closeDialog', vm.payload);
    },

    updateTable() {
      const vm = this;
      const currentHandset = vm.$props.handsets.filter(
        (x) => x.handsetID == vm.modem
      )[0];
      const discount = vm.setDiscount;
      const monthly = parseFloat(
        (currentHandset.rrpEx - discount) / vm.rowData[0].contract
      ).toFixed(2);
      vm.rowData = [
        {
          name: currentHandset.model,
          contract: vm.item.contractTerm,
          price: vm.price,
          upfront: vm.item.contractTerm > 0 ? 0 : currentHandset.rrpEx,
          monthly: vm.item.contractTerm > 0 && monthly > 0 ? monthly : 0,
          discount: discount,
        },
      ];
    },
  },
  watch: {
    backupType: {
      handler() {
        this.price = this.backupType.toLowerCase() === '4g' ? 12.0 : 80.0;
        this.rowData[0].price = this.price;
      },
    },
  },
  mounted() {
    this.payload = {
      id: this.dialog.target == 'edit' ? this.item.dataBackup.id : 0,
      orderID: this.dialog.target == 'edit' ? this.item.orderID : 0,
      internetID: this.dialog.target == 'edit' ? this.item.internetID : 0,
      ratePlanID: this.dialog.target == 'edit' ? this.item.ratePlanID : 0,
      hardwareID: 0,
    };

    this.rowData = [
      {
        name: '',
        contract: this.item.contractTerm,
        price: 0,
        discount: 0,
        upfront: 0,
        monthly: 0,
      },
    ];

    if (
      this.item.internetType &&
      this.item.internetType.toLowerCase() === 'nbn'
    ) {
      this.backupType = '4g';
      this.isNbn = true;
    } else {
      this.isNbn = false;
      this.backupType = 'assure';
    }
    if (this.dialog.target == 'edit') {
      this.modem = this.item.dataBackup.hardwareID;
      this.updateTable();
    }
  },
};
</script>

<style>
.backupDialogRadioGroup .v-input--radio-group {
  display: block !important;
  width: 100% !important;
}
</style>
